export const seoConfig = {
  defaultMeta: {
    title: "Shree Balaji Corporation - Leading Supplier of PET Straps & Industrial Packaging Solutions",
    description: "Leading supplier of PET straps, bale covers, leather washers, and pneumatic strapping machines for cotton ginning and pressing industries since 1970. Based in Akola, Maharashtra.",
    keywords: "PET straps, bale covers, cotton packaging, ginning washers, strapping machines, industrial packaging, cotton industry, Akola Maharashtra, pneumatic tools",
    image: "/assets/logo-social.png"
  },
  
  pages: {
    products: {
      title: "Industrial Packaging Products - PET Straps, Bale Covers & Strapping Machines",
      description: "Comprehensive range of industrial packaging products including PET straps, bale covers, leather washers, and pneumatic strapping machines for cotton ginning and pressing industries.",
      keywords: `
        PET straps cotton bales, polyester strapping bands, plastic strapping rolls, industrial strapping material,
        cotton bale covers, polyester bale covers, weather resistant covers, bale protection covers,
        ginning washers, leather washers, cotton ginning parts, ginning machine accessories,
        pneumatic strapping machines, air powered strapping tools, cotton bale strapping equipment,
        industrial packaging solutions, cotton industry supplies, ginning industry equipment,
        pressing industry materials, cotton mill supplies, textile industry packaging,
        Akola industrial suppliers, Maharashtra packaging company, cotton belt suppliers,
        PET strap manufacturers, bale cover suppliers, ginning equipment dealers,
        cotton packaging materials, agricultural packaging supplies, farm equipment accessories,
        cotton harvest packaging, cotton storage solutions, cotton transport packaging,
        industrial strapping supplies, heavy duty packaging materials, bulk packaging solutions,
        cotton ginning supplies, cotton pressing equipment, cotton mill accessories,
        polyester strapping tape, PP strapping alternative, eco-friendly packaging straps,
        rust resistant iron straps, galvanized iron strapping, metal strapping rolls,
        cotton industry Maharashtra, ginning mills Akola, cotton processing equipment,
        agricultural machinery parts, farm equipment supplies, rural industry solutions,
        B2B packaging supplies, wholesale packaging materials, bulk industrial supplies,
        cotton bale binding, agricultural produce packaging, crop packaging solutions,
        industrial grade strapping, commercial packaging equipment, factory packaging supplies
      `.replace(/\s+/g, ' ').trim(),
      breadcrumbs: [
        { name: "Home", url: "/" },
        { name: "Products", url: "/products" }
      ]
    }
  },
  
  productCategories: {
    1: {
      title: "PET Straps for Cotton Bales - High Tensile Strength Packaging Straps",
      description: "Premium quality PET straps, polyester strapping bands, and plastic strapping rolls specifically designed for cotton bale packaging. High tensile strength, eco-friendly, and industry-specific design for reliable cotton bale securing and agricultural packaging needs.",
      keywords: `
        patti,PET straps, polyester straps, plastic strapping bands, PET strapping rolls, polyester strapping tape,
        cotton bale straps, agricultural strapping, farm packaging straps, crop packaging bands,
        high tensile straps, industrial strapping material, heavy duty packaging straps,
        eco-friendly strapping, recyclable packaging straps, green packaging solutions,
        cotton industry straps, ginning mill supplies, pressing mill strapping,
        bale binding straps, agricultural produce strapping, textile packaging straps,
        PP strap alternative, polypropylene strap substitute, steel strap replacement,
        16mm PET straps, narrow width strapping, precision cut strapping bands,
        weather resistant straps, UV resistant strapping, outdoor packaging straps,
        cost effective strapping, bulk strapping supplies, wholesale PET straps,
        Maharashtra PET straps, Akola strapping supplier, cotton belt packaging,
        machine grade strapping, hand strapping tools compatible, pneumatic tool compatible
      `.replace(/\s+/g, ' ').trim()
    },
    2: {
      title: "Bale Covers - Weather Resistant Cotton Bale Protection Covers",
      description: "Premium quality cotton and polyester bale covers for superior protection during storage and transportation. Weather-resistant, durable covers for cotton bales, agricultural produce protection, and outdoor storage solutions.",
      keywords: `
        bale covers, cotton bale covers, polyester bale covers, agricultural covers,
        weather resistant covers, waterproof bale covers, UV resistant covers,
        cotton storage covers, bale protection sheets, farm storage covers,
        outdoor storage covers, crop protection covers, agricultural tarpaulins,
        heavy duty bale covers, industrial covers, textile bale covers,
        ginning mill covers, pressing mill covers, cotton mill supplies,
        monsoon protection covers, rain resistant covers, all weather covers,
        breathable bale covers, moisture resistant covers, fungus resistant covers,
        custom size covers, tailored bale covers, made to measure covers,
        bulk bale covers, wholesale agricultural covers, commercial bale covers,
        Maharashtra bale covers, Akola agricultural supplies, cotton belt covers,
        storage shed covers, warehouse covers, transportation covers,
        cotton harvest covers, seasonal storage covers, long term storage covers
      `.replace(/\s+/g, ' ').trim()
    },
    3: {
      title: "Ginning Washers - Premium Leather Washers for Cotton Ginning Machines",
      description: "High-grade leather washers, ginning machine parts, and cotton processing accessories specifically designed for cotton ginning machines. Fine finish, rugged design, and long service life for industrial cotton processing applications.",
      keywords: `
        ginning washers, leather washers, cotton ginning parts, ginning machine accessories,
        cotton processing parts, textile machinery parts, industrial washers,
        leather gaskets, machinery seals, equipment washers, mechanical washers,
        ginning mill parts, cotton mill components, processing equipment parts,
        replacement washers, spare parts ginning, maintenance parts cotton,
        high grade leather parts, premium leather washers, industrial leather goods,
        machinery maintenance supplies, equipment repair parts, factory replacement parts,
        cotton ginning supplies, textile processing supplies, agricultural machinery parts,
        ginning equipment accessories, cotton processing accessories, mill maintenance parts,
        Maharashtra ginning parts, Akola machinery supplies, cotton belt equipment,
        OEM replacement parts, aftermarket ginning parts, compatible ginning accessories,
        bulk ginning supplies, wholesale machinery parts, commercial ginning parts,
        long lasting washers, durable leather parts, wear resistant washers
      `.replace(/\s+/g, ' ').trim()
    },
    4: {
      title: "Pneumatic Strapping Machines - Professional Cotton Bale Packaging Equipment",
      description: "Professional-grade pneumatic strapping machines, air-powered packaging tools, and cotton bale packaging equipment for efficient industrial packaging. Heavy-duty construction, user-friendly operation, and low maintenance pneumatic tools.",
      keywords: `
        pneumatic strapping machines, air powered strapping tools, pneumatic packaging equipment,
        cotton bale strapping machines, industrial strapping tools, packaging machinery,
        automatic strapping machines, semi-automatic strapping equipment, manual strapping tools,
        heavy duty strapping machines, commercial packaging equipment, factory strapping tools,
        PET strap machines, polyester strapping equipment, plastic strap tools,
        ginning mill equipment, cotton mill machinery, pressing mill tools,
        agricultural packaging machines, farm equipment tools, rural industry machinery,
        pneumatic tools supplier, air tool distributor, compressed air equipment,
        strapping machine parts, packaging equipment accessories, machinery maintenance,
        portable strapping machines, mobile packaging equipment, field strapping tools,
        high performance strapping, efficient packaging solutions, productivity tools,
        Maharashtra packaging machines, Akola industrial equipment, cotton belt machinery,
        B2B packaging equipment, wholesale strapping machines, bulk packaging tools,
        cost effective strapping, reliable packaging equipment, durable industrial tools
      `.replace(/\s+/g, ' ').trim()
    },
    5: {
      title: "Hoop Iron Straps - Heavy-Duty Industrial Iron Strapping & Metal Bands",
      description: "Industrial-grade hoop iron straps, galvanized iron strapping rolls, and metal strapping bands for heavy-duty bale packaging. Superior strength, rust-resistant coating, and corrosion protection for secure cotton bale packaging and industrial applications.",
      keywords: `
        hoop iron straps, iron strapping rolls, metal strapping bands, steel strapping,
        galvanized iron straps, rust resistant strapping, corrosion proof strapping,
        heavy duty metal straps, industrial iron strapping, commercial metal bands,
        cotton bale iron straps, agricultural metal strapping, farm packaging bands,
        high tensile iron straps, strong metal strapping, durable iron bands,
        weather resistant iron straps, outdoor metal strapping, all weather bands,
        bulk iron strapping, wholesale metal straps, commercial iron bands,
        Maharashtra iron straps, Akola metal suppliers, cotton belt strapping,
        traditional strapping methods, conventional packaging materials, time tested strapping,
        cost effective metal strapping, economical iron bands, budget strapping solutions,
        replacement for steel straps, alternative to wire strapping, substitute for chains,
        ginning mill iron straps, cotton mill metal bands, pressing mill strapping,
        agricultural iron supplies, farm metal products, rural industry strapping
      `.replace(/\s+/g, ' ').trim()
    }
  },

  // Long-tail keyword variations
  longTailKeywords: {
    regional: [
      "cotton packaging supplies Akola", "industrial packaging Maharashtra", "ginning equipment Vidarbha",
      "cotton industry supplies central India", "agricultural packaging western Maharashtra",
      "cotton belt packaging solutions", "Deccan plateau cotton supplies"
    ],
    businessType: [
      "B2B packaging supplier", "wholesale industrial packaging", "bulk packaging distributor",
      "commercial packaging solutions", "factory direct packaging", "manufacturer packaging supplies"
    ],
    industry: [
      "cotton ginning industry", "cotton pressing mills", "textile processing industry",
      "agricultural packaging sector", "rural industry supplies", "farm equipment accessories"
    ],
    applications: [
      "cotton bale transportation", "agricultural produce storage", "crop packaging solutions",
      "harvest packaging materials", "seasonal storage supplies", "warehouse packaging"
    ]
  }
};
